export default __webpack_public_path__ + "static/media/logo.6dfa80c6.svg";